import { StyleObj } from '../types';

export type IfMixin = (
  condition: any,
  whenTrue: StyleObj,
  whenFalse?: StyleObj,
) => StyleObj;

export const ifMixin: IfMixin = (condition, whenTrue, whenFalse = {}) => {
  return condition ? whenTrue : whenFalse;
};
